export default __webpack_public_path__ + "static/reed-1-e175b034a1b9bd8a6fc69e3579a4ec71.jpg";